import { isEmbedded, useParentPostMessage } from '@yes.technology/react-toolkit'
import { useEffect } from 'react'
import { useSessionStorage } from 'shared/hooks'
import useSignUpPath from './useSignUpPath'

const SignUp = () => {
  const { postMessage } = useParentPostMessage()

  const path = useSignUpPath()

  const [redirectOrigin] = useSessionStorage(
    'redirectOrigin',
    window.fallbackOrigin
  )

  useEffect(() => {
    if (isEmbedded()) {
      postMessage({ type: 'redirect', url: `/${path}` })
      return
    }

    const url = new URL(redirectOrigin)
    window.location.href = `${url.origin}/${path}`
  }, [postMessage, redirectOrigin, path])

  return null
}

export default SignUp
